import React, { useContext, useState } from 'react';

import {
  Button,
  CrudContext,
  FormatText,
  FormInput,
  FormSubmitButton,
  MasterDetailForm,
  Row,
  Widget,
} from '@digital/ui';
import { Modal, Tooltip } from 'antd';
import { UploadFile } from '@app/components';
import ContextProvider from '@app/hooks/useQuestionario';
import { incluirAnexoGovernanca } from '@app/api/governancaAprovacao';

interface Props {
  dados: any;
}

function ModalIncluirAnexo(props: Props) {
  const [exibirModal, setExibirModal] = useState(false);
  const { governancaAprovacaoId, update, setUpdate } = useContext(ContextProvider);
  const { dados } = props;

  const handleSubmit = (values: any) => {
    if (governancaAprovacaoId) {
      values.governancaAprovacaoId = governancaAprovacaoId;
      if (dados) values.id = dados.id;
      incluirAnexoGovernanca(values).then(data => {
        if (data.valid) {
          setUpdate(!update);
          setExibirModal(false);
        }
      });
    }
  };

  return (
    <>
      {dados === undefined ? (
        <Button
          style={{ marginBottom: '16px' }}
          type="primary"
          onClick={() => {
            setExibirModal(true);
          }}>
          INCLUIR ANEXO
        </Button>
      ) : (
        <Tooltip title="Incluir Arquivo">
          <Button
            icon="ui-upload"
            onClick={() => {
              setExibirModal(true);
            }}
          />
        </Tooltip>
      )}
      <Modal
        title="INCLUIR ANEXO"
        width="680px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        {exibirModal && (
          <MasterDetailForm
            key="formAnexo"
            onSubmit={handleSubmit}
            initialValues={dados}
            actions={[
              <Button
                type="link"
                onClick={() => {
                  setExibirModal(false);
                }}
                key="close">
                Fechar
              </Button>,
              <FormSubmitButton noIcon type="primary" key="save">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row>
                <FormInput name="descricao" label="Descrição" span={12} required />
                <UploadFile nameFormData={'arquivo'} label={'INSERIR ANEXO'} hasFile={false} type="primary" />
              </Row>
            </Widget>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
}
export default ModalIncluirAnexo;
